import type { BannerPayload } from "@services/banners/commands/cmdCreateBanner";

/**
 * Router state from the banner editor's "Preview on Partner Dashboard" (MPN-2266). It lives
 * only in history state -- never the URL, never the server -- so a shared link carries no
 * preview. Everything in it is a string, null or boolean: history state is structured-cloned,
 * and a Luxon DateTime would lose its prototype.
 */
export interface BannerPreviewState {
    bannerPreview: BannerPayload;
    bannerId?: string;
    /** The editor's path, for Back to Editor: /banners/new or /banners/<uuid>/edit. */
    returnTo: string;
}

const isStringOrNull = (v: unknown) => v === null || typeof v === "string";

/** The preview in `state`, or null when it is anything else. */
export function readPreview(state: unknown): BannerPreviewState | null {
    if (!state || typeof state !== "object") return null;
    const { bannerPreview: p, bannerId, returnTo } = state as Record<string, unknown>;
    if (typeof returnTo !== "string" || !returnTo) return null;
    if (bannerId !== undefined && typeof bannerId !== "string") return null;
    if (!p || typeof p !== "object") return null;
    const b = p as Record<string, unknown>;
    const valid =
        typeof b.message === "string"
        && typeof b.link_text === "string"
        && typeof b.link_url === "string"
        && isStringOrNull(b.starts_at)
        && isStringOrNull(b.ends_at)
        && typeof b.is_draft === "boolean";
    return valid ? (state as BannerPreviewState) : null;
}
